import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Uploader } from "../../components/uploader/Uploader";
import { manualUploadAPI } from "../../../api/manualupload/manualUploadAPI";
import Alert from "react-popup-alert";
//import Modal, { useModalState } from "react-simple-modal-provider";

function FileUploaderContainer({ onFileAdded }) {
  const [alert, setAlert] = React.useState({
    type: "error",
    text: "Tracciato non valido.",
    show: false,
  });

  function onCloseAlert() {
    setAlert({
      type: "",
      text: "",
      show: false,
    });
  }

  function onShowAlert(type) {
    setAlert({
      type: type,
      text: "Tracciato non valido.",
      show: true,
    });
  }

  const voidRecord = [];
  const [data, setData] = useState(voidRecord);

  return (
    <>
      <Uploader onFileAdded={onFileAdded} />

      <div style={{ display: "flex", justifyContent: "center", marginTop: 0 }}>
        <Alert
          header={"Errore"}
          btnText={"Close"}
          text={alert.text}
          type={alert.type}
          show={alert.show}
          onClosePress={onCloseAlert}
          pressCloseOnOutsideClick={true}
          showBorderBottom={true}
          alertStyles={{}}
          headerStyles={{ fontSize: 25 }}
          textStyles={{ fontSize: 20 }}
          buttonStyles={{}}
        />
      </div>
    </>
  );
}

export const FileUploader = connect(null, null)(FileUploaderContainer);
